import { createDrawerNavigator } from '@react-navigation/drawer';
import { StackScreenProps } from '@react-navigation/stack';
import { View } from 'react-native';
import colors, { appTheme } from '../../config/colors';
import { TherapistStackParamList } from '../../navigations/TherapistStack';

import { AboutNeolexon } from '@/screens/TherapistSettings/AboutNeolexon/';
import { Account } from './Account';
import { Consent } from './Consent';
import { Contact } from '@/screens/TherapistSettings/Contact';
import { DrawerContent } from './DrawerContent';
import { LockScreen } from '@/screens/TherapistSettings/LockScreen/';

export type SettingsDrawerParamList = {
  AboutNeolexon: undefined;
  Account: undefined;
  Consent: undefined;
  Contact: undefined;
  LockScreen: undefined;
};
const Drawer = createDrawerNavigator<SettingsDrawerParamList>();

export function TherapistSettings({
  navigation,
}: StackScreenProps<TherapistStackParamList, 'TherapistSettings'>) {
  return (
    <View style={{ flex: 1 }}>
      <Drawer.Navigator
        screenOptions={{
          sceneContainerStyle: {
            backgroundColor: colors.newUI.therapist.bgBlue10,
          },
          drawerStyle: {
            width: 250,
            borderRightWidth: 0,
          },
          drawerAllowFontScaling: false,
          drawerType: 'permanent',
          headerShown: false,
          drawerActiveTintColor: colors.white,
          drawerActiveBackgroundColor: appTheme.primary,
        }}
        drawerContent={DrawerContent}
      >
        <Drawer.Group>
          <Drawer.Screen
            name="Account"
            options={{ title: 'Benutzerkonto' }}
            component={Account}
          />
          <Drawer.Screen
            name="LockScreen"
            options={{ title: 'Sperrbildschirm' }}
            component={LockScreen}
          />
          <Drawer.Screen
            name="Consent"
            options={{ title: 'Einwilligungen' }}
            component={Consent}
          />

          <Drawer.Screen
            name="AboutNeolexon"
            options={{ title: 'Über die App' }}
            component={AboutNeolexon}
          />
          <Drawer.Screen
            name="Contact"
            options={{ title: 'Kontakt' }}
            component={Contact}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </View>
  );
}
